module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pact_wrap"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268477d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/edit/pact3.vue
// module id = 504
// module chunks = 0